export class ProductPlanModel {
    name;
    type;
    params;
    priceBeforeDiscount;
    discountPercentage;
    price;
    onDemandPrice;
    hardCap;
    responseStatus;
    constructor({ name, type, params, discountPercentage, price, priceBeforeDiscount, responseStatus }) {
        this.name = name;
        this.type = type;
        this.params = params;
        this.priceBeforeDiscount = priceBeforeDiscount;
        this.discountPercentage = discountPercentage;
        this.price = price;
        this.responseStatus = responseStatus;
    }
}
//# sourceMappingURL=product-plan.js.map